import React from 'react';
import { ThumbnailOverlayBadge } from '../../ThumbnailOverlayBadge';
import { useTranslations } from '../../../../../../shared/src/hooks/use-translations.hook';
import { ThumbnailFavoriteBadge } from '../../ThumbnailFavoriteBadge';
import { useTrackOpenGameGtm } from '../../../../../../shared/src/hooks/user-track-open-game-gtm.hook';

export const CasinoThumbnailOverlayBasic = ({
    overlayBadges,
    openGameHandler,
    showFavorites,
    name,
    ctaTextRef,
    gameId,
}) => {
    const { t } = useTranslations();

    const trakcOpenGame = useTrackOpenGameGtm();

    const openGame = () => {
        trakcOpenGame(gameId);
        openGameHandler();
    };

    return (
        <div className="casino-thumbnail__hover">
            <div className="casino-thumbnail__hover-mode-top">
                {/*left overlay badge*/}
                <div className="casino-thumbnail__hover-badges-left">
                    {overlayBadges?.left && <ThumbnailOverlayBadge
                        badgeName={overlayBadges.left.badgeName}
                        badgeText={overlayBadges.left.badgeText}
                        onClickHandler={overlayBadges.left.onClickHandler}
                    />}
                </div>

                <div className="casino-thumbnail__hover-mode-fill"
                    onClick={openGame}
                ></div>

                {showFavorites && <ThumbnailFavoriteBadge gameId={gameId} />}
            </div>

            <div className="casino-thumbnail__hover-mode-bottom">
                <div className="casino-thumbnail__hover-mode-fill"
                    onClick={openGame}
                ></div>

                <div className="casino-thumbnail__hover-badges-right">
                    {overlayBadges?.right && <ThumbnailOverlayBadge
                        badgeName={overlayBadges.right.badgeName}
                        badgeText={overlayBadges.right.badgeText}
                        onClickHandler={overlayBadges.right.onClickHandler}
                        openToRight={false}
                    />}
                </div>
            </div>

            {/*play text CTA*/}
            <div
                className="casino-thumbnail__play-text"
                onClick={openGame}
            >
                <span
                    ref={ctaTextRef}
                >{`${t('play')} ${name}`}</span>
            </div>
        </div>
    );
};
